import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import { Map } from '@mui/icons-material';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { AuthContext } from '../../AuthContext/AuthContext'; // adjust path
import './../Lease Module/CustomBottomNav.css';

const navItems = [ 
  { key: 'home', icon: <HomeIcon />, route: '/dashboard', label: 'Home' },
  { key: 'list', icon: <Map />, route: '/new-map', label: 'Map' },
  { key: 'saves', icon: <FavoriteBorderIcon />, route: '/new-saves', label: 'Saves' },
  { key: 'inbox', icon: <MailOutlineIcon />, route: '/inboxlist', label: 'Inbox' },
];

const GUEST_BLOCKED_KEYS = ['saves', 'inbox'];

const CustomBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isGuest } = useContext(AuthContext);

  const [currentKey, setCurrentKey] = useState('');
  const [openGuestModal, setOpenGuestModal] = useState(false);
  const navRef = useRef(null);

  /* ==========================
     SET ACTIVE TAB
  ========================== */
  useEffect(() => {
    const activeItem =
      navItems.find((item) =>
        location.pathname.startsWith(item.route)
      )?.key || 'home';

    setCurrentKey(activeItem);
  }, [location.pathname]);

  /* ==========================
     NAV CLICK HANDLER
  ========================== */
  const handleNav = (item) => {
    // 🚫 Guest restriction
    if (isGuest && GUEST_BLOCKED_KEYS.includes(item.key)) {
      setOpenGuestModal(true);
      return;
    }

    setCurrentKey(item.key);
    navigate(item.route);
  };

  /* ==========================
     INDICATOR POSITION
  ========================== */
  useEffect(() => {
    const current = navRef.current?.querySelector(
      `.nav-item[data-key="${currentKey}"]`
    );
    const indicator = navRef.current?.querySelector('.nav-indicator');

    if (current && indicator) {
      const { offsetLeft, offsetWidth } = current;
      indicator.style.left = `${offsetLeft + offsetWidth / 2 - 25}px`;
    }
  }, [currentKey]);

  return (
    <>
      <div className="nav-wrapper">
        <div className="nav-bar" ref={navRef}>
          {navItems.map((item) => (
            <div
              key={item.key}
              data-key={item.key}
              className={`nav-item ${
                currentKey === item.key ? 'nav-item-active' : ''
              }`}
              onClick={() => handleNav(item)}
            >
              {item.icon}
              <div className="nav-label">{item.label}</div>
            </div>
          ))}
          <div className="nav-indicator" />
        </div>
      </div>

      {/* ==========================
          GUEST MODAL
      ========================== */}
      <Dialog open={openGuestModal} onClose={() => setOpenGuestModal(false)}>
        <DialogTitle>Login Required</DialogTitle>
        <DialogContent>
          <Typography>
            Please Register and login to access this feature
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenGuestModal(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => navigate('/')}
          >
            Login
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomBottomNav;
